import { render } from "./maternity_head.vue?vue&type=template&id=9a98b212&scoped=true"
import script from "./maternity_head.vue?vue&type=script&lang=js"
export * from "./maternity_head.vue?vue&type=script&lang=js"

import "./maternity_head.vue?vue&type=style&index=0&id=9a98b212&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a98b212"]])

export default __exports__